<div class="copy-link">
  <p class="url-label">
    {{ label }}
  </p>
  <div *ngIf="link" class="copy-link__content">
    <div class="copy-link__content__text">
      <p id="profileLink" class="copy-link__content__link">
        {{ link }}
      </p>
    </div>
    <div class="copy-link__content__actions">
      <button
        class="copy-link__content__actions__button"
        mat-flat-button
        color="primary"
        type="button"
        (click)="onCopy()"
        matTooltip="Copy {{ link }} to clipboard"
      >
        <mat-icon class="copy_icon"> content_copy </mat-icon>
      </button>
    </div>
  </div>
</div>
